// PrivacyPolicyPage.js
const PrivacyPolicyPage = () => (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "auto", lineHeight: "1.6" }}>
        <h2>Privacy Policy</h2>
        <p><strong>Last Updated:</strong> May 29, 2025</p>

        <p>
            This Privacy Policy describes how we collect, use, and protect your information when you use our AI-powered quiz generation platform.
        </p>

        <h3>1. Information We Collect</h3>
        <p>We may collect the following types of data:</p>
        <ul>
            <li><strong>Personal Information:</strong> Name, email, or login credentials (if applicable).</li>
            <li><strong>Content Input:</strong> Paragraphs, questions, or text you input to generate quizzes.</li>
            <li><strong>Usage Data:</strong> Page visits, quiz generation activity, and browser/device info.</li>
        </ul>

        <h3>2. How We Use Your Information</h3>
        <p>We use the information to:</p>
        <ul>
            <li>Generate quizzes from your input text</li>
            <li>Improve platform performance and user experience</li>
            <li>Provide customer support</li>
            <li>Send occasional updates (if opted in)</li>
        </ul>

        <h3>3. Data Storage and Security</h3>
        <p>
            We store data on secure servers. We use encryption and access control to protect personal information. However, no system is 100% secure, and we cannot guarantee complete protection.
        </p>

        <h3>4. Sharing of Data</h3>
        <p>We do <strong>not sell</strong> your personal data. We may share data only with:</p>
        <ul>
            <li>Service providers (e.g., cloud storage or analytics)</li>
            <li>Legal authorities if required by law</li>
        </ul>

        <h3>5. Cookies and Tracking</h3>
        <p>
            We may use cookies or similar technologies to enhance your experience and track usage patterns. You can disable cookies via your browser settings.
        </p>

        <h3>6. Your Rights</h3>
        <p>You have the right to:</p>
        <ul>
            <li>Access and review your personal data</li>
            <li>Request correction or deletion of your data</li>
            <li>Withdraw consent or close your account</li>
        </ul>

        <h3>7. Children's Privacy</h3>
        <p>
            If you are under 13, you may only use the platform with parental or guardian consent. We do not knowingly collect data from children under 13 without such consent.
        </p>

        <h3>8. Changes to This Policy</h3>
        <p>
            We may update this Privacy Policy occasionally. Continued use of the platform indicates acceptance of the updated policy.
        </p>

        <h3>9. Contact Us</h3>
        <p>
            For any questions or data-related requests, please contact us at: <a href="mailto:ylyn.org@gmail.com">ylyn.org@gmail.com</a>
        </p>
    </div>
);

export default PrivacyPolicyPage;
